<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            class="pa-2"
            :headers="headers"
            :items="recipes"
            item-key="keyValue"
            :items-per-page="itemsPerPage"
            hide-default-footer
            fixed-header
            dense
            show-expand
            :loading="loading"
            loading-text="Loading all data....please wait"
            must-sort
            sort-by="favourite"
            sort-desc
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar height="80" flat>
                <v-toolbar-title
                  >Recipe Book ({{ recipes.length }})</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  clearable
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="loading || saving"
                  icon
                  color="primary"
                  @click="Refresh()"
                  ><v-icon>mdi-refresh</v-icon></v-btn
                >
              </v-toolbar>
            </template>
            <template v-slot:item.favourite="{ item }">
              <v-icon
                small
                class="mr-2"
                color="primary"
                @click="ToggleFavourite(item)"
              >
                {{ item.favourite ? "mdi-heart" : "mdi-heart-outline" }}
              </v-icon>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="amber lighten-4 pa-2">
                <b>METHOD</b><br />{{ item.method }}
              </td>
            </template>
            <template v-slot:item.name="{ item }">
              <div class="primary--text row-pointer" @click="EditRecipe(item)">
                {{ item.name }}
              </div>
            </template>
            <template v-slot:item.yield="{ item }">
              <span>{{ formatNumber(item.yield, 2) }}</span>
            </template>
            <template v-slot:item.weight="{ item }">
              <span>{{ formatNumber(item.weight, 2) }} Kg</span>
            </template>
            <template v-slot:item.unitWeight="{ item }">
              <span>{{ formatNumber(item.weight / item.yield, 3) }} Kg</span>
            </template>
            <template v-slot:item.otherYield="{ item }">
              <span>{{ formatNumber(item.otherYield, 2) }}</span>
            </template>
            <template v-slot:item.otherWeight="{ item }">
              <span>{{ formatNumber(item.otherWeight, 2) }} Kg</span>
            </template>
            <template v-slot:item.otherUnitWeight="{ item }">
              <span
                >{{
                  formatNumber(item.otherWeight / item.otherYield, 3)
                }}
                Kg</span
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col> </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import utilities from "@/services/Utilities.js";
import { mapState } from "vuex";

export default {
  components: {},
  name: "Recipes",
  computed: {
    ...mapState(["recipes", "loading", "saving"])
  },
  data() {
    return {
      search: "",
      showDialog: false,
      editedIndex: -1,
      editedItem: {},
      itemsPerPage: -1,
      headers: [
        { text: "", value: "favourite" },
        { text: "Name", value: "name" },
        { text: "Ingredients used", value: "ingredients.length", align: "end" },
        { text: "Yield", value: "yield", align: "end" },
        { text: "Weight", value: "weight", align: "end" },
        { text: "Unit weight", value: "unitWeight", align: "end" },
        { text: "Other yield", value: "otherYield", align: "end" },
        { text: "Other weight", value: "otherWeight", align: "end" },
        { text: "Other unit weight", value: "otherUnitWeight", align: "end" }
      ]
    };
  },
  methods: {
    async ToggleFavourite(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      if (!("favourite" in this.editedItem)) {
        this.$set(this.editedItem, "favourite", false);
      }
      this.editedItem.favourite = !this.editedItem.favourite;
      this.editedItem = await this.$store.dispatch(
        "SaveRecipe",
        this.editedItem
      );
    },
    EditRecipe(item) {
      this.$store.state.recipe = item;
      this.$router.push("/recipebook/page");
    },
    async Refresh() {
      await this.$store.dispatch("LoadData", true);
    },
    formatNumber(value, fractionDigits = 2) {
      return utilities.formatNumber(value, fractionDigits);
    },
    formatCurrency(value, fractionDigits = 2) {
      return utilities.formatCurrency(value, fractionDigits);
    },
    formatPercent(value, fractionDigits = 2) {
      return utilities.formatPercent(value, fractionDigits);
    }
  }
};
</script>
<style lang="css" scoped>
.row-pointer {
  cursor: pointer;
}
</style>
